module.exports = __webpack_public_path__ + "img/794w.0a7e7ca.jpg";